import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import AppExtensionsSDK from "@pipedrive/app-extensions-sdk";
import axios from "axios";
import { Spinner } from "react-bootstrap";

const Iframe = () => {
  const [searchParams] = useSearchParams();

  const [isLoading, setIsLoading] = useState(false);

  const initalizePipedriveSDK = async (id) => {
    try {
      await new AppExtensionsSDK({ identifier: id }).initialize({
        size: { height: 100 },
      });
    } catch (error) {
      console.log(error);
      let message;
      if (error.response && error.response.data.message)
        message = error.response.data.message;
      else message = error.message;
      console.log(message);
    }
  };

  const trigger = async () => {
    try {
      setIsLoading(true);
      const userId = searchParams.get("userId");
      const companyId = searchParams.get("companyId");
      const selectedIds = searchParams.get("selectedIds");
      await axios.get(
        "https://wmhp74tnbd.execute-api.eu-central-1.amazonaws.com/updatePipedriveSQS",
        {
          params: {
            userId,
            companyId,
            selectedIds,
          },
        }
      );
    } catch (error) {
      console.log(error);
      let errorMessage;
      if (error.response && error.response.data.message)
        errorMessage = error.response.data.message;
      else errorMessage = error.message;
      console.log(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const id = searchParams.get("id");
    if (id) {
      initalizePipedriveSDK(id);
    }
    trigger();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{ height: "100vh" }}
      className="d-flex flex-column justify-content-center align-items-center"
    >
      {isLoading ? (
        <div className="d-flex flex-column justify-content-center align-items-center nav-loading-container">
          <div className="d-flex flex-row justify-content-center align-items-center">
            <Spinner animation="border" variant="primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </div>
      ) : (
        <p>Deal Triggered Successfully.</p>
      )}
    </div>
  );
};

export default Iframe;
